"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMinibagVisible = void 0;
// This might be outdated after recent changes - TODO
const isMinibagVisible = () => {
  const element = document.querySelector('[data-testid=Checkout-shopping-mini-bag-fading-wrapper]');
  if (!element) {
    return false;
  }
  return window.getComputedStyle(element).visibility === 'visible';
};
exports.isMinibagVisible = isMinibagVisible;
